import { createFileRoute } from "@tanstack/react-router";
import { Backgrounds } from "@/features/backgrounds";

export const Route = createFileRoute("/_authenticated/backgrounds/")({
  component: Backgrounds,
});
